/* =========================================
   MUBLIG Mobile Drawer
   Datei: assets/mublig-mobile-drawer.js
   ========================================= */

(function () {
  if (window.__mubligMobileDrawerLoaded) return;
  window.__mubligMobileDrawerLoaded = true;

  function getDrawer() {
    return document.querySelector('[data-mublig-mobile-drawer]');
  }

  function openDrawer() {
    var drawer = getDrawer();

    if (!drawer) return;

    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');

    document.body.classList.add('mublig-mobile-drawer-open');

    window.setTimeout(function () {
      drawer.classList.add('is-visible');
    }, 10);
  }

  function closeDrawer() {
    var drawer = getDrawer();

    if (!drawer) return;

    drawer.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('mublig-mobile-drawer-open');

    window.setTimeout(function () {
      if (!document.body.classList.contains('mublig-mobile-drawer-open')) {
        drawer.hidden = true;
      }
    }, 260);
  }

  function toggleNewsletter(toggle) {
    var card = toggle.closest('[data-mublig-newsletter-card]');
    if (!card) return;

    var isOpen = card.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (isOpen) {
      window.setTimeout(function () {
        var input = card.querySelector('input[type="email"]');
        if (input) input.focus();
      }, 120);
    }
  }

  function toggleSubmenu(toggle) {
    var item = toggle.closest('[data-mublig-drawer-item]');
    if (!item) return;

    var submenu = item.querySelector('[data-mublig-drawer-submenu]');
    if (!submenu) return;

    var isOpen = item.classList.toggle('is-open');

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    submenu.hidden = !isOpen;
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var newsletterToggle = event.target.closest('[data-mublig-newsletter-toggle]');
      var submenuToggle = event.target.closest('[data-mublig-drawer-submenu-toggle]');
      var openTrigger = event.target.closest(
        '[data-mublig-mobile-drawer-open], [data-mublig-mobile-menu-open]'
      );
      var closeTrigger = event.target.closest('[data-mublig-mobile-drawer-close]');

      if (newsletterToggle) {
        event.preventDefault();
        toggleNewsletter(newsletterToggle);
        return;
      }

      if (submenuToggle) {
        event.preventDefault();
        toggleSubmenu(submenuToggle);
        return;
      }

      if (openTrigger) {
        event.preventDefault();
        openDrawer();
        return;
      }

      if (closeTrigger) {
        event.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEvents);
  } else {
    bindEvents();
  }

  window.MubligMobileDrawer = {
    open: openDrawer,
    close: closeDrawer
  };
})();